import { HttpRequest, HttpEvent, HttpHandler, HttpInterceptor, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
  
@Injectable()
export class NoCacheHeadersInterceptor implements HttpInterceptor {

  constructor(private authenticationService: AuthenticationService, private loading: LoadingService) {

  }  
 
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {    
    return next.handle(this.addToken(request)).pipe(
      map((event: HttpEvent<any>) =>
      {
        if (event instanceof HttpResponse) {
          console.log('Http Reponse: ', event);
            if(event.body && event.body.statusCode && event.body.statusCode==403 && event.body.code!="invalid_username" && event.body.code!="incorrect_password"){              
              this.loading.presentToast("Invalid authentication: Please login again");             
              console.log("Invalid authentication: Please login again");
              this.authenticationService.logOut();
              throw new HttpErrorResponse({error: "Invalid token: Please login again"});
            }
        }
        return event;
      }),
      catchError(err =>
      { 
        //dont show toast again
        if(err.error && err.error != "Invalid token: Please login again") {        
          this.loading.presentToast("Internet connection problem");         
        }
        throw err;
      }
      ));
  }

    // Add our current access token from the service if present
  private addToken(req: HttpRequest<any>) {
     if(this.authenticationService.isUserLoggedIn) {
        return req.clone({
        headers: new HttpHeaders({
           "Authorization": `Bearer ${this.authenticationService.getCurrentUser.token}`,
        })
      });
    } else {
      return req;
    }
  }
 
}